<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{this.data?.options?.title}}
      </h6>
    </div>
    <div class="flex items-center mr-1">
      <span mat-dialog-close class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex flex-col space-y-2 zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
    <ng-container>
        <div class="flex" [ngClass]="{'border border-red-500 rounded-md': ((markup?.touched || formSubmitted) && markup?.errors?.required)}">
          <input 
              type="number"
              [min]="0"
              [step]="stepValue"
              restrictNumberDecimal
              [(ngModel)]="markupValue"
              [ngModelOptions]="{standalone: true}"
              placeholder="{{'text.markup' | translate}}"
              #markup="ngModel"
              [ngClass]="{'border-l-0 border-t-0 border-b-0': ((markup?.touched || formSubmitted) && markup?.errors?.required)}"
              class="form-control block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
              required
          > 
          <span [matMenuTriggerFor]="dropdown"
                  [ngClass]="{'border-r-0 border-t-0 border-b-0': ((markup?.touched || formSubmitted) && markup?.errors?.required)}"
                  class="inline-flex items-center px-3 text-md text-gray-900 border border-l-0 border-gray-300 rounded-r-md">
            <span class="text-lg" *ngIf="markupType === 'FLAT'">
              <i class="ti ti-plus"></i>
            </span>
            <span  class="text-lg" *ngIf="markupType === 'PERCENTAGE'">
              <i class="ti ti-percentage"></i>
            </span>
            <span  class="text-lg" *ngIf="markupType === 'MULTIPLIER'">
              <i class="ti ti-x"></i>
            </span>
            <em class="text-xl" class="ti ti-chevron-down text-base font-semibold ml-2"></em>
          <mat-menu #dropdown="matMenu" class="markup-menu">
              <div>
                  <a mat-menu-item class="h-10" (click)="this.markupType = 'FLAT'">
                      <span class="ml-2 text-base space-x-2"> 
                        <i class="ti ti-plus"></i> <span>{{'text.flat' | translate}}</span> 
                      </span>
                  </a>
              </div>
              <div>
                  <a mat-menu-item class="h-10" (click)="this.markupType = 'PERCENTAGE'">
                      <span class="ml-2 text-base space-x-2">
                        <i class="ti ti-percentage"></i><span>{{'text.percentage' | translate}}</span>
                      </span>
                  </a>
              </div>
              <div>
                  <a mat-menu-item class="h-10" (click)="this.markupType = 'MULTIPLIER'">
                      <span class="ml-2 text-base space-x-2">
                        <i class="ti ti-x"></i><span>{{'text.multiplier' | translate}}</span>
                      </span>
                  </a>
              </div>
          </mat-menu>
          </span>
      </div>
      <p class="text-base primary-font text-red-500" *ngIf="(markup?.touched || formSubmitted) && markup?.errors?.required">{{'text.field_is_required' | translate}}</p>
    </ng-container>
    <div class="rounded-md bg-blue-50 px-4 py-3">
      <div class="flex">
          <div class="flex-shrink-0">
          <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
          </div>
          <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-base text-blue-700">{{"text.bulk_update_markup.notification" | translate}}</p>
          </div>
      </div>
    </div>
  </div>
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    <div class="flex justify-around space-x-4">
        <button type="button" mat-stroked-button mat-dialog-close class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
        <button (click)="updateMarkup()" class="min-w-24 px-6 btn-small items-center py-2 border b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
          <span>{{'text.update_markup' | translate}}</span>
        </button>
    </div>
  </div>
</div> 